import { render, staticRenderFns } from "./MenuHome.vue?vue&type=template&id=4a876d55&scoped=true"
import script from "./MenuHome.vue?vue&type=script&lang=ts"
export * from "./MenuHome.vue?vue&type=script&lang=ts"
import style0 from "./MenuHome.vue?vue&type=style&index=0&id=4a876d55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a876d55",
  null
  
)

export default component.exports